<template>
  <div
    class="box store-home-page"
    :class="{
      'to-bottom': hasLoadPaytype,
      'no-login': !isLogin,
      'transparent-bg-mode': isTransparentBgMode
    }"
  >
    <!-- password自动填充问题 弹窗前移 -->
    <!-- 选角弹窗 -->
    <transition name="fade" mode="out-in">
      <select-role-popup v-if="isSelectRolePopup"></select-role-popup>
    </transition>
    <!-- 破冰弹窗组 -->
    <template v-for="popup in showPopupList">
      <welcome-popup :popupInfo="popup"></welcome-popup>
    </template>
    <!-- 登录弹窗 -->
    <transition name="fade" mode="out-in">
      <login-popup v-show="isLoginPopup && isFinishInit"></login-popup>
    </transition>

    <top-header :showCouponBtn="showCouponBtn"></top-header>
    <pwa-award></pwa-award>
    <PwaGetAwardSuccessPopup
      v-if="visibleGetPwaAwardSuccessPopup"
      @close="switchVisibleGetPwaAwardSuccessPopup(false)"
    ></PwaGetAwardSuccessPopup>
    <div v-if="!isLandscape" class="mobile-placeholder"></div>
    <top-banner></top-banner>
    <notice></notice>
    <pwa-install-home
      v-if="!isLandscape && isLogin && !hasSaveDesktopTask"
      :location="3"
    ></pwa-install-home>
    <pwa-goto-award-tips-popup
      v-if="visibleGotoAwardTipsPopup"
      @close="closeGotoAwardTipsPopup"
    ></pwa-goto-award-tips-popup>
    <login-info
      class="login-info"
      :showCouponBtn="true"
      :showSwicthBtn="true"
      :showIcon="true"
      :showAccountBg="true"
    ></login-info>
    <div class="content">
      <div class="container product-container">
        <hero-section></hero-section>
        <template v-if="!isLandscape">
          <img
            class="content-bg"
            v-if="timeAwardList.length && moduleBg"
            :src="moduleBg"
            alt="moduleBg"
          />
          <limited-time-activity></limited-time-activity>
        </template>
        <select-product>
          <template #limitedTimeActivity v-if="isLandscape">
            <img
              class="content-bg"
              v-if="timeAwardList.length && moduleBg"
              :src="moduleBg"
              alt="moduleBg"
            />
            <limited-time-activity></limited-time-activity>
          </template>
          <template #default>
            <coupon-btn
              v-if="!isLandscape && ![386, 456].includes(+gameId)"
              :showCouponBtn="showCouponBtn"
            ></coupon-btn>
          </template>
        </select-product>
      </div>
    </div>
    <pay-collect></pay-collect>
    <faq></faq>
    <to-top></to-top>
    <page-footer :class="{ 'order-bg': hasLoadPaytype }"></page-footer>
    <coupon-list-popup
      v-if="isShowPaytypePopupCoupon"
      popupType="paytype"
      :enableCouponList="paytypeEnableCouponList"
      :disableCouponList="paytypeDisableCouponList"
      :expireCouponList="paytypeExpireCouponList"
      :languages="letter"
      @closeCouponPopup="hidePaytypeCouponPopup"
    ></coupon-list-popup>
    <coupon-list-popup
      v-if="isShowGameCouponPopup"
      popupType="game"
      :enableCouponList="gameCouponEnableList"
      :disableCouponList="gameCouponDisableList"
      :expireCouponList="gameCouponExpireList"
      :languages="letter"
      @closeCouponPopup="hideGameCouponPopup"
    ></coupon-list-popup>

    <transition name="fade" mode="out-in">
      <coupon-vip-popup
        v-if="isShowVipCouponPopup"
        @closeCouponPopup="hideVipCouponPopup"
        :couponList="vipCouponList"
      ></coupon-vip-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <coupon-vip-popup
        v-if="isShowBirthCouponPopup"
        @closeCouponPopup="hideBirthCouponPopup"
        :couponList="birthCouponList"
      ></coupon-vip-popup>
    </transition>
    <!-- 全局提示弹窗 -->
    <PopupWindow
      v-if="globalTipsVisible"
      type="tips"
      :languages="letter"
      :content="globalTipsContent"
      textAlign="center"
      @onConfirm="globalTipsVisible = false"
      @onCancel="globalTipsVisible = false"
    ></PopupWindow>
    <!-- 购物车删除弹窗 -->
    <PopupWindow
      v-if="showDetelePopup"
      :languages="letter"
      :content="letter.check_remove_cart"
      textAlign="center"
      @onConfirm="removeProduct(deleteItem)"
      @onCancel="cancelSubProduct"
    ></PopupWindow>
    <PopupWindow
      type="tips"
      v-if="visibleRightCenterPopup"
      :confirm="letter.go"
      :languages="letter"
      :content="offLineNotice"
      :title="letter.notice"
      :autoHeight="true"
      textAlign="center"
      @onConfirm="goRightsCenter"
      @onCancel="visibleRightCenterPopup = false"
      class="right-center-popup"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleRightsNotice"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="pnsRightCenterNoticeTitle"
      :content="pnsRightCenterNotice"
      :autoHeight="true"
      :confirm="letter.v3GoTo"
      @onConfirm="confirmRightsNotice"
      @onCancel="closeRightsNotice"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleCloseCouponSend"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="pnsCloseCouponSendTitle"
      :content="pnsCloseCouponSendContent"
      :autoHeight="true"
      :confirm="letter.v3GoTo"
      @onConfirm="confirmRightsNotice"
      @onCancel="closeCouponSend"
    ></PopupWindow>
    <PopupWindow
      v-if="visiblePnsPayDown"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="pnsPayDownTitle"
      :content="pnsPayDownContent"
      :autoHeight="true"
      @onConfirm="closePnsPayDown"
      @onCancel="closePnsPayDown"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleMayiKoNotice"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="mayiKoNoticeTitle"
      :content="mayiKoNoticeContentV35"
      :autoHeight="true"
      @onConfirm="closeMayiKoNotice"
      @onCancel="closeMayiKoNotice"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleMayiPayChangeNotice"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="mayiPayChangeTitle"
      :content="mayiPayChangeContent"
      :autoHeight="true"
      @onConfirm="closeMayiPayChangeNotice"
      @onCancel="closeMayiPayChangeNotice"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleKOneDownLimitActivity"
      type="tips"
      textAlign="left"
      :languages="letter"
      title=""
      :content="kOneDownLimitActivityContent"
      :autoHeight="true"
      @onConfirm="closeKOneDownLimitActivity"
      @onCancel="closeKOneDownLimitActivity"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleKOneDownVip"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="kOneDownVipTitle"
      :content="kOneDownVipContent"
      :autoHeight="true"
      @onConfirm="closeKOneDownVip"
      @onCancel="closeKOneDownVip"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleJpPayDown"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="jpPayDownTitle"
      :content="jpPayDownContent"
      :autoHeight="true"
      @onConfirm="closeJpPayDown"
      @onCancel="closeJpPayDown"
    ></PopupWindow>
    <PopupWindow
      v-if="isJpLimitPopup"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="jpLimitPopupTitle"
      :content="jpLimitPopupContent"
      :autoHeight="true"
      :disableClose="true"
      :hideButton="true"
      style="z-index: 1001"
    ></PopupWindow>
    <!-- 450 商品未上架提示，不可关闭 -->
    <PopupWindow
      v-if="isProductNotOnSalePopup"
      type="tips"
      textAlign="center"
      :languages="letter"
      title=""
      :content="productNotOnSaleContent"
      :disableClose="true"
      :hideButton="true"
      style="z-index: 1001"
    ></PopupWindow>
    <LandscapeTip></LandscapeTip>
    <transition name="fade" mode="out-in">
      <Loading v-show="loading"></Loading>
    </transition>
  </div>
</template>

<script>
import Faq from '@components/officialTopupNew/common/Faq.vue';
import ToTop from '@components/officialTopupNew/common/ToTop.vue';
import CouponBtn from '@components/officialTopupNew/common/couponBtn.vue';
import PwaAward from '@components/officialTopupNew/pwa/PwaAward.vue';
import PwaInstallHome from '@components/officialTopupNew/pwa/PwaInstallHome.vue';
import TopBanner from '@components/officialTopupNew/TopBanner.vue';
import TopHeader from '@components/officialTopupNew/TopHeader.vue';
import Notice from '@components/officialTopupNew/activity/Notice.vue';
import WelcomePopup from '@components/officialTopupNew/activity/WelcomePopup.vue';
import LimitedTimeActivity from '@components/officialTopupNew/activity/LimitedTimeActivity.vue';
import HeroSection from '@components/officialTopupNew/activity/HeroSection.vue';
import SelectProduct from '@components/officialTopupNew/product/SelectProduct.vue';
import SelectPaytype from '@components/officialTopupNew/paytype/SelectPaytype.vue';
import PayCollect from '@components/officialTopupNew/paytype/PayCollect.vue';
import CouponVipPopup from '@components/officialTopupNew/coupon/CouponVipPopup.vue';
import CouponListPopup from '@components/officialTopupNew/coupon/CouponListPopup.vue';
import PwaGotoAwardTipsPopup from '@components/officialTopupNew/pwa/PwaGotoAwardTipsPopup.vue';
import Loading from '@components/officialTopupNew/Loading.vue';
import coupon from '@mixins/officialTopupNew/coupon';
import login from '@mixins/officialTopupNew/login';
import userStatus from '@mixins/officialTopupNew/userStatus';
import iconSetting from '@mixins/officialTopupNew/iconSetting';
import style from '@mixins/officialTopupNew/style';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import allStorePopup from '@mixins/allStorePopup';
import transparentBg from '@mixins/officialTopupNew/transparentBg';
import PwaGetAwardSuccessPopup from '@components/officialTopupNew/pwa/PwaGetAwardSuccessPopup.vue';
import LoginPopup from '@components/officialTopupNew/login/LoginPopup.vue';
import LoginInfo from '@components/officialTopupNew/login/LoginInfo.vue';
import SelectRolePopup from '@components/officialTopupNew/login/SelectRolePopup.vue';
import PageFooter from '@components/officialTopupNew/PageFooter.vue';
import { GET_ACTIVITY_LIST } from '@store/officialTopupNew/activity';
import {
  GET_PRODUCT_LIST,
  SET_GLOBAL_TIPS_VISIBLE,
  GET_LASTED_STORE_ROLE,
  RESOLVE_PRODUCT_ID_FOR_COIN
} from '@store/officialTopupNew';
import {
  UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP,
  UPDATE_VISIBLE_GET_PWA_AWARD_SUCCESS_POPUP
} from '@store/officialTopupNew/page';

import bridge from '@utiles/officialStore/bridge';

import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import openActivity, { NOTICE_POPUP_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
import { trackStagePoint } from '@utiles/officialTopupNew/speedPoint';
import jpLimitPopup from '@mixins/jpLimitPopup';
import { pageType, viewPage } from '@plugins/biPoint/_configWebstoreV35';
import LandscapeTip from '@components/officialTopupNew/LandscapeTip.vue';

const PRODUCT_NOT_ON_SALE_GAME_ID = 450;
const PRODUCT_NOT_ON_SALE_TEXT = {
  'zh-CN': '商品暂未上架，敬请期待！',
  'zh-TW': '商品暫未上架，敬請期待！',
  'en-US': 'The product is not yet available, please stay tuned!',
  'ja-JP': '商品はまだ販売されていません。どうぞご期待ください！',
  'ko-KR': '상품이 아직 출시되지 않았습니다. 기대해 주세요!',
  'th-TH': 'สินค้ายังไม่วางจำหน่าย โปรดรอติดตาม!',
  'vi-VN': 'Sản phẩm chưa được lên kệ, vui lòng chờ đón nhé!',
  'ru-RU': 'Товар пока не доступен, следите за обновлениями!',
  'de-DE': 'Das Produkt ist noch nicht verfügbar. Bitte bleiben Sie gespannt!',
  'fr-FR': "Le produit n'est pas encore en ligne, restez à l'écoute !",
  'id-ID': 'Produk belum tersedia, nantikan segera!',
  'es-ES': 'El producto aún no está disponible, ¡manténgase atento!',
  'pt-PT': 'O produto ainda não está disponível, fique atento!',
  'tr-TR': 'Ürün henüz yayında değil, takipte kalın!',
  'pl-PL': 'Produkt nie jest jeszcze dostępny, bądźcie czujni!',
  'it-IT': 'Il prodotto non è ancora disponibile, restate sintonizzati!',
  'nl-NL': 'Het product is nog niet beschikbaar, blijf op de hoogte!',
  'ms-MY': 'Produk masih belum tersedia, sila nantikan!',
  'ar-SA': 'المنتج غير متوفر بعد، تابعونا!'
};

export default {
  name: 'webStorePage',
  mixins: [
    login,
    userStatus,
    coupon,
    iconSetting,
    style,
    cartAddAndDetail,
    allStorePopup,
    transparentBg,
    jpLimitPopup
  ],
  data() {
    return {
      visibleRightCenterPopup: false, // 权益中心弹窗
      showCouponBtn: false,
      couponBtnObserver: null,
      couponBtnSetupTimer: null,
      couponBtnRetryTimer: null,
      rightCenterCookieTimer: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      loading: state => state.loading,
      hasLoadPaytype: state => state.hasLoadPaytype,
      letter: state => state.letter,
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin,
      popupList: state => state.activity.popupList,
      timeAwardList: state => state.activity.timeAwardList,
      globalTipsVisible: state => state.globalTipsVisible,
      globalTipsContent: state => state.globalTipsContent,
      showDetelePopup: state => state.cart.showDetelePopup,
      picList: state => state.page.picList,
      isFinishInit: state => state.page.isFinishInit,
      visibleGotoAwardTipsPopup: state => state.page.visibleGotoAwardTipsPopup,
      visibleGetPwaAwardSuccessPopup: state =>
        state.page.visibleGetPwaAwardSuccessPopup
    }),
    ...mapGetters(['isJpPlatform', 'gameInfoConfig', 'hasSaveDesktopTask']),
    moduleBg() {
      return this.picList?.giftlistbg;
    },
    cart() {
      return this.$store.state.cart;
    },
    showPopupList() {
      // 因为权重高的在前面所以倒序显示覆盖前面弹窗
      return this.popupList.filter(item => item?.basic?.isShow).reverse();
    },
    globalTipsVisible: {
      get() {
        return this.$store.state.globalTipsVisible;
      },
      set(val) {
        this.$store.commit(SET_GLOBAL_TIPS_VISIBLE, val);
      }
    },
    showRightCenterPopup() {
      const gameInfoConfig = this.gameInfoConfig;
      if (
        !gameInfoConfig?.offLineTime ||
        !gameInfoConfig?.isShowPreRightsPopup
      ) {
        return false;
      }
      const announcementEndTime = new Date(gameInfoConfig.offLineTime);
      const currentTime = new Date();
      const currentTimeZoneOffset = currentTime.getTimezoneOffset();
      const currentUTCTime = new Date(
        currentTime.getTime() - currentTimeZoneOffset * 60000
      );
      if (currentUTCTime > announcementEndTime) {
        return false;
      }
      return true;
    },
    showRightsCenter() {
      const gameInfoConfig = this.gameInfoConfig;
      if (
        !gameInfoConfig?.isOnlineRightsCenter ||
        !gameInfoConfig?.onlineRightsCenterTime
      ) {
        return false;
      }
      const startTime = new Date(gameInfoConfig.onlineRightsCenterTime);
      const currentTime = new Date();
      const currentTimeZoneOffset = currentTime.getTimezoneOffset();
      const currentUTCTime = new Date(
        currentTime.getTime() - currentTimeZoneOffset * 60000
      );
      if (currentUTCTime < startTime) {
        return false;
      }
      return true;
    },
    offLineNotice() {
      return (
        this.letter.preRightsIntro.replace(
          '${offLineDate}',
          this.gameInfoConfig?.offLineDate[this.lang] ||
            this.gameInfoConfig?.offLineDate['en-US'] ||
            ''
        ) || ''
      );
    },
    isProductNotOnSalePopup() {
      return +this.gameId === PRODUCT_NOT_ON_SALE_GAME_ID;
    },
    productNotOnSaleContent() {
      return (
        PRODUCT_NOT_ON_SALE_TEXT[this.lang] ||
        PRODUCT_NOT_ON_SALE_TEXT['en-US']
      );
    }
  },
  watch: {
    isLogin: {
      async handler(newVal) {
        // trackStagePoint('watch_is_login', {
        //   isLogin: newVal
        // });
        if (newVal) {
          let productIdToMatch = '';
          if (globalConfig.getHrefParam('productId')) {
            productIdToMatch = await this.$store.dispatch(
              RESOLVE_PRODUCT_ID_FOR_COIN,
              {
                productId: globalConfig.getHrefParam('productId'),
                gameId: this.gameId
              }
            );
          }
          this.getActivityList();
          if (
            globalConfig.getHrefParam('roleId') &&
            globalConfig.getHrefParam('serverId')
          ) {
            // 如果链接有角色参数则使用链接的角色参数
            this.$store
              .dispatch(GET_PRODUCT_LIST, {
                roleId: globalConfig.getHrefParam('roleId'),
                serverId: globalConfig.getHrefParam('serverId'),
                roleName: globalConfig.getHrefParam('roleName'),
                productId:
                  productIdToMatch || globalConfig.getHrefParam('productId'),
                // 如果有转换商品ID，则cpProductId置空
                cpProductId: productIdToMatch
                  ? ''
                  : globalConfig.getHrefParam('cpProductId'),
                devicePlate: globalConfig.getHrefParam('devicePlate'),
                remark: globalConfig.getHrefParam('remark'),
                appLanguage: this.$store.state.lang,
                language: this.$store.state.lang,
                packageName: globalConfig.getHrefParam('packageName')
              })
              .then(data => {
                if (
                  data?.role_id === 'null' ||
                  data?.role_name === 'null' ||
                  !data?.role_id ||
                  !data?.role_name ||
                  !data?.product_list?.length
                ) {
                  // 没有获取到角色走旧流程
                  this.$store.dispatch(GET_LASTED_STORE_ROLE);
                  this.selectRole();
                } else {
                  this.checkRoleExist(data?.server_id, data?.server_sid);
                }
              })
              .catch(() => {
                this.$store.dispatch(GET_LASTED_STORE_ROLE);
                this.selectRole();
              });
          } else {
            // 如果链接没有角色参数则使用接口返回的上一次默认储值角色
            this.$store
              .dispatch(GET_PRODUCT_LIST)
              .then(data => {
                if (
                  data?.role_id === 'null' ||
                  data?.role_name === 'null' ||
                  !data?.role_id ||
                  !data?.role_name ||
                  !data?.product_list?.length ||
                  bridge.runInsdk()
                ) {
                  // 没有获取到角色走旧流程
                  // 在游戏内打开走旧流程，根据SDK参数选择用户当前角色
                  this.$store.dispatch(GET_LASTED_STORE_ROLE);
                  this.selectRole();
                } else {
                  this.checkRoleExist(data?.server_id, data?.server_sid);
                }
              })
              .catch(() => {
                this.$store.dispatch(GET_LASTED_STORE_ROLE);
                this.selectRole();
              });
          }

          this.loadVipCouponInfo();
          this.checkShowRightCenterPopup();
          // 登录后 LoginInfo 优惠券按钮才挂载，需重新建立观察
          this.$nextTick(() => {
            this.setupCouponButtonObserver();
          });
        } else {
          this.clearCouponButtonObserver();
          this.showCouponBtn = false;
        }
      }
    },
    // 活动是根据语言参数接口由接口处理多语言，所以语言变化时需要重新获取活动列表
    lang: {
      handler(newVal) {
        if (!newVal) return;
        this.$store.dispatch(GET_ACTIVITY_LIST, {
          pos: ['index_banner', 'lamp', 'time_award', 'hero_section']
        });
      }
    },
    isTransparentBgMode: {
      handler(newVal) {
        const htmlEl = document.querySelector('html');
        const bodyEl = document.querySelector('body');

        if (!htmlEl || !bodyEl) return;

        if (newVal) {
          // 透明背景模式：添加 transparent-bg-mode，移除 not-transparent-bg-mode
          htmlEl.classList.add('transparent-bg-mode');
          htmlEl.classList.remove('not-transparent-bg-mode');
          bodyEl.classList.add('transparent-bg-mode');
          bodyEl.classList.remove('not-transparent-bg-mode');
        } else {
          // 非透明背景模式：移除 transparent-bg-mode，添加 not-transparent-bg-mode
          htmlEl.classList.remove('transparent-bg-mode');
          htmlEl.classList.add('not-transparent-bg-mode');
          bodyEl.classList.remove('transparent-bg-mode');
          bodyEl.classList.add('not-transparent-bg-mode');
        }
      },
      immediate: true
    }
  },
  beforeCreate() {
    viewPage(pageType.homePage);
  },
  created() {
    // trackStagePoint('home_created');
    // 2025-04-10 修复日本平台游戏内拉起第三方支付时，gmo渠道无法正常储值，改为外跳浏览器
    if (this.isJpPlatform) {
      if (bridge.runInsdk() && window.location.pathname == '/mobile/paytype') {
        bridge.callSdkMethod('openBrowser', {
          url: window.location.href,
          loginDir: 1,
          appendParams: 1
        });
      }
    }
  },
  mounted() {
    this.couponBtnSetupTimer = setTimeout(() => {
      this.couponBtnSetupTimer = null;
      this.setupCouponButtonObserver();
    }, 2000);
  },
  beforeDestroy() {
    this.clearHomeTimers();
    this.clearCouponButtonObserver();
  },
  methods: {
    clearHomeTimers() {
      if (this.couponBtnSetupTimer) {
        clearTimeout(this.couponBtnSetupTimer);
        this.couponBtnSetupTimer = null;
      }
      if (this.couponBtnRetryTimer) {
        clearTimeout(this.couponBtnRetryTimer);
        this.couponBtnRetryTimer = null;
      }
      if (this.rightCenterCookieTimer) {
        clearTimeout(this.rightCenterCookieTimer);
        this.rightCenterCookieTimer = null;
      }
    },
    clearCouponButtonObserver() {
      if (this.couponBtnRetryTimer) {
        clearTimeout(this.couponBtnRetryTimer);
        this.couponBtnRetryTimer = null;
      }
      if (this.couponBtnObserver) {
        this.couponBtnObserver?.disconnect();
        this.couponBtnObserver = null;
      }
    },
    setupCouponButtonObserver() {
      // 已存在观察者时先断开，避免重复创建
      this.clearCouponButtonObserver();

      const MAX_RETRY = 10;
      const setupObserver = (retryCount = 0) => {
        const loginInfoCouponBtn =
          document.getElementById('loginInfoCouponBtn');
        if (!loginInfoCouponBtn) {
          // 未登录或优惠券按钮未挂载时默认显示顶部按钮；限制重试次数避免无限轮询
          this.showCouponBtn = true;
          if (retryCount >= MAX_RETRY) return;
          this.couponBtnRetryTimer = setTimeout(() => {
            this.couponBtnRetryTimer = null;
            setupObserver(retryCount + 1);
          }, 1000);
          return;
        }

        // 获取header高度，用于设置rootMargin
        const topHeader = document.getElementById('topHeader');
        const headerHeight = topHeader ? topHeader.offsetHeight : 0;

        // 创建IntersectionObserver实例
        this.couponBtnObserver = new IntersectionObserver(
          entries => {
            // 只有一个目标元素，所以只处理第一个entry
            const entry = entries[0];

            // 设置按钮显示状态：当元素不在视口中时显示顶部按钮
            this.showCouponBtn = !entry.isIntersecting;
          },
          {
            root: null, // 使用视口作为根
            // 设置rootMargin，将header高度考虑进去
            rootMargin: `-${headerHeight}px 0px 0px 0px`,
            threshold: 0 // 任何可见度变化都触发回调
          }
        );

        // 开始观察目标元素
        this.couponBtnObserver.observe(loginInfoCouponBtn);
      };

      // 初始设置
      setupObserver();
    },
    goRightsCenter() {
      let jumpLink = '';
      if (this.gameInfoConfig?.isOnlineRightsCenter && this.showRightsCenter) {
        jumpLink = this.gameInfoConfig?.preRightsPopupLink
          ? this.gameInfoConfig?.preRightsPopupLink
          : this.gameInfoConfig?.rightsCenterLink;
        openActivity(NOTICE_POPUP_ACTIVITY, jumpLink, {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
      } else {
        jumpLink = `${window.location.href.replace(
          'officialTopupNew.html',
          'officialStore.html'
        )}vip_score`;
        sdkOpenLink({
          link: jumpLink
        });
      }
      this.visibleRightCenterPopup = false;
    },
    checkShowRightCenterPopup() {
      if (!this.showRightCenterPopup) {
        return;
      }
      let RIGHT_CENTER_POPUP_STATE = 'RIGHT_CENTER_POPUP_STATE' + this.gameId;
      if (!+globalConfig.getCookie(RIGHT_CENTER_POPUP_STATE)) {
        this.visibleRightCenterPopup = true;
        // 3s后设置cookie, 避免刷新误触发
        if (this.rightCenterCookieTimer) {
          clearTimeout(this.rightCenterCookieTimer);
        }
        this.rightCenterCookieTimer = setTimeout(() => {
          this.rightCenterCookieTimer = null;
          globalConfig.setCookie(RIGHT_CENTER_POPUP_STATE, 1);
        }, 3000);
      }
    },
    closeGotoAwardTipsPopup() {
      this.$store.commit(UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP, false);
    },
    switchVisibleGetPwaAwardSuccessPopup(bool) {
      this.$store.commit(UPDATE_VISIBLE_GET_PWA_AWARD_SUCCESS_POPUP, bool);
    }
  },
  components: {
    Faq,
    ToTop,
    PwaAward,
    PwaInstallHome,
    TopBanner,
    TopHeader,
    Notice,
    HeroSection,
    LimitedTimeActivity,
    SelectProduct,
    CouponVipPopup,
    CouponListPopup,
    SelectPaytype,
    Loading,
    LoginPopup,
    LoginInfo,
    SelectRolePopup,
    PageFooter,
    WelcomePopup,
    Faq,
    CouponBtn,
    PayCollect,
    PwaGotoAwardTipsPopup,
    PwaGetAwardSuccessPopup,
    LandscapeTip
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.box {
  overflow: visible;
  position: relative;
  width: 100%;
  height: auto;
  padding-bottom: 140px;
  background-color: $backgroundColor;

  &.no-login {
    padding-bottom: 360px;
  }

  &.to-bottom {
    padding-bottom: 0;
  }

  &.transparent-bg-mode {
    background-color: transparent;
  }
}

.content {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px auto 0;
  min-height: 480px;

  &.hidden-content {
    visibility: hidden;
    pointer-events: none;
  }

  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 0;
  }
}

.account-info {
  border-radius: 20px;
}

.container {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 0 40px;
}

.content-box {
  position: relative;
  font-size: 0;
}
.order-bg {
  background-color: $backgroundColor;
}

.right-center-popup {
  z-index: 1001;
  ::v-deep .tips-content {
    max-height: unset;
  }
}

#ssr-page.landscape {
  .box {
    padding-bottom: 0 !important;
  }
  .content {
    max-width: 1507px;
    padding-bottom: 200px;
    margin: 28px auto 40px;

    &-bg {
      border-radius: 20px;
    }
  }

  .container {
    padding: 0;
  }

  .order-bg {
    background-color: #111111;
  }
}

/* iPad横向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .box {
    overflow: visible;
    padding-bottom: 0;
  }
}

.mobile-placeholder {
  margin-top: 140px;
}
</style>

<style lang="scss">
.store-home-page.transparent-bg-mode {
  .content,
  .header,
  .cont,
  .pwa-home,
  .login-info,
  .faq,
  .to-top,
  .footer,
  .notice-wrap,
  .notice {
    visibility: hidden;
    pointer-events: none;
  }
}
html.transparent-bg-mode {
  background-color: transparent;
}
body.transparent-bg-mode {
  background-color: transparent;
  overflow-y: hidden;
}
</style>
